import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router';
import { Button } from '@hostfully/ui-components';
import { appUrlParamName } from './ResetPassword.constants';
import useBackToLogin from '@/hooks/useBackToLogin';
import {
  PublicFormButtonContainer,
  PublicFormSubtitle,
  PublicFormTitle,
} from '@/pages/_layouts/publicLayout/publicForm.styles';

const ResetErrorState = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const handleBackToLogin = useBackToLogin();

  const handleRequestNewLink = () => {
    const next = new URLSearchParams();
    const appUrl = searchParams.get(appUrlParamName);
    if (appUrl) {
      next.set(appUrlParamName, appUrl);
    }
    const query = next.toString();
    navigate(query ? `/forgot-password?${query}` : '/forgot-password');
  };

  return (
    <div data-testid="reset-error">
      <PublicFormTitle data-testid="reset-error-title">
        {t('pageForgotPassword.errorTitle')}
      </PublicFormTitle>
      <PublicFormSubtitle data-testid="reset-error-subtitle">
        {t('pageForgotPassword.errorSubtitle')}
      </PublicFormSubtitle>
      <PublicFormButtonContainer>
        <Button
          data-testid="reset-error-back-to-login"
          variant="textPrimary"
          onClick={handleBackToLogin}
        >
          {t('pageForgotPassword.backToLogin')}
        </Button>
        <Button
          data-testid="reset-error-request-new"
          size="large"
          onClick={handleRequestNewLink}
        >
          {t('pageForgotPassword.requestNewLink')}
        </Button>
      </PublicFormButtonContainer>
    </div>
  );
};

export default ResetErrorState;
